import { CancelToken } from 'axios';
import { http } from '../helpers/axiosHelper';

export default class FileService {
   async createFile(formData: FormData) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/media', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
         })
         .then((response) => {
            if (response.data && response.status) {
               return response.data;
            } else {
               throw Error(`Kon bestand niet opslaan`);
            }
         })
         .catch((error) => {
            if (error.response && error.response.status === 413) {
               throw Error(`Bestand te groot`);
            }
            throw Error(`Kon bestand niet opslaan`);
         });
   }
   async editFile(fileId: Number, body: any) {
      return await http.put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/media/' + fileId, body).then((response) => {
         return response.data;
      });
   }
   async getFile(fileId: Number, cancelToken?: CancelToken) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/media/' + fileId, {
            cancelToken: cancelToken,
         })
         .then((response) => {
            return response.data;
         });
   }
   async deleteFile(fileId: Number) {
      return await http
         .delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/media/' + fileId)
         .then((response) => {
            if (response.data && response.status) {
               return response.data;
            } else {
               throw Error(`Kon bestand niet verwijderen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon bestand niet verwijderen`);
         });
   }
}
